import { get, isArray, split } from 'lodash'
import _kwworkchat from 'kw-workchat'
import * as _ww from '@wecom/jssdk'
import * as kwsdk from 'kwsdk'
import { ajax } from './http'
import { LocationType } from './location'
import { isAndroidApp, isIosApp } from './cookie'
import { agentId, appSignCode, corpId, corpSignCode } from '@/constant/workchat'
import { Toast } from 'vant'
import { getImageMedia, getVideoMedia, uploadImageMedia } from '@/api/common'
import { isInFrame } from './helper'
import { geoCoderByLatLng } from 'bs-sdk'

let parentKwworkchat: any, parentWW: any
try {
  // 当前页面处于iframe中（企微云客场景），获取父页面的企微sdk
  if (isInFrame()) {
    parentKwworkchat = window.parent && window.parent.window.kwworkchat
    parentWW = window.parent && window.parent.window.ww
  }
} catch (e) {
  // 跨域访问parent会报错
  console.error(e)
}

export const kwworkchat = parentKwworkchat || _kwworkchat
export const ww = parentWW || _ww

/*
 *********************** 商城App与人客合一原生方法 ***********************
 */
type OptionsType = Partial<{
  targetClass: string
  methodType: string
  methodName: string
  methodArgsTypes: string
  parm: {
    parmClass?: string
    parmKey?: string
    parmValue?: string
  }[]
}>
/* 调用原生方法 */
export function setNativeInfo(options: OptionsType, callback?: string) {
  if (!isIosApp() && !isAndroidApp()) return

  options = options || {}
  options.targetClass = options.targetClass || ''
  options.methodType = options.methodType || '0'
  options.methodName = options.methodName || ''
  options.parm = options.parm || []

  const str = JSON.stringify(options)

  // console.log(str)

  if (isIosApp()) {
    window.app &&
      window.app.jsNavtiveHandle &&
      window.app.jsNavtiveHandle(str, callback)
  } else if (isAndroidApp()) {
    window.localjs &&
      window.localjs.invokeNativeMethod &&
      window.localjs.invokeNativeMethod(str)
  }
}
/* 设置标题 */
export function setTitle(title = '孕产·亲子') {
  kwsdk.setTitle(title)
}

/* 设置标题及刷新分享 */
export function setPage({ title = '孕产·亲子', refresh = true, share = true }) {
  kwsdk.setPageInfo({
    title,
    refresh,
    share
  })
  if (share) {
    setShare({
      title
    })
  }
}

export type ShareConfigType = {
  channel?: string //分享渠道2图文分享 5微信 6朋友圈	7新浪 3QQ 8复制链接
  imageByte?: string //图文
  title?: string // 标题
  desc?: string // 秒杀
  imgUrl?: string // 图片
  link?: string // 链接
  subtext?: string //价格
  kwsharescenetype?: number //linkType，请求分享key参数
  linkid?: string //linkContentId，请求分享key参数
  remark?: string //remark，请求分享key参数
  dpH5?: number
  dpinfoH5?: string
  wipeflag?: string
  /* 微信小程序分享设置 */
  userName?: string //小程序username
  webpageUrl?: string // 低版本网页链接
  path?: string // 小程序页面路径
  mpTitle?: string // 分享标题
  mpDescription?: string // 分享内容
  thumbUrl?: string // 分享图片
  mpType?: number // 小程序版本0正式版;1开发版;2体验版;
  page?: string
  scene?: string
  /* 不同类型素材分享 */
  copyFlag?: string //复制功能开关，0关1开（目前只在人客使用）
  shareCopyContent?: string //自定义复制文案[面板上方的复制文案h5直接传]
  materialPicArr?: string //海报素材列表(仅限人客) 逗号分隔 eg (xx,xx,xx)
  materialPicUrl?: string //图片素材跳转链接(仅限人客)
  materialVideoUrl?: string //视频素材跳转链接(仅限人客)
}
/* 设置分享信息 */
export function setShare(config: ShareConfigType = {}, miniData = {}) {
  // 分享参数透传，详见https://p6fpo8391v.feishu.cn/wiki/wikcnzr4vGfXx6kipG7u5JLFh0A#ey8dtZ
  const shareInfo = {
    title: '孕产·亲子',
    desc: '孩子王孕产亲子平台，为您优选品质服务',
    link: location.href,
    ...config
  }
  // 微信小程序分享设置
  const shareObj = {
    ...shareInfo,
    userName: shareInfo.userName /* || 'gh_362b01c44275' */, //传userName时，微信分享会使用小程序，不传默认链接分享
    webpageUrl: shareInfo.link,
    path:
      shareInfo.path ||
      `pages/mall-index/index?refererH5=${encodeURIComponent(shareInfo.link)}`,
    mpTitle: shareInfo.title,
    mpDescription: shareInfo.desc,
    thumbUrl: shareInfo.imgUrl,
    mpType: 0
  }
  try {
    console.log(shareObj)
    kwsdk.setShareInfo({
      shareObj,
      /* 孩子王特卖小程序分享中转页分享参数，透传，默认带入shareObj中的title，thumbUrl或imgUrl， link, 
      参数文档https://code.haiziwang.com/frontend-document/projects-document/blob/master/wx-mp/mp-share-middle-for-h5.md */
      isMinPage: true,
      minShare: {
        backgroundImage: shareInfo.imgUrl,
        ...miniData
      },
      wxName: 'mall'
    })
  } catch (e) {
    console.log(e)
  }
}

/* 拉起分享面板 */
export function openShareBoard() {
  kwsdk.share()
}

/* 拉起分享到微信好友 */
export function openShareWxChat() {
  if (isIosApp()) {
    const options = {
      targetClass: '',
      methodType: '0',
      methodName: 'singleShareType_',
      parm: [
        {
          parmClass: 's',
          parmValue: '1'
        }
      ]
    }
    setNativeInfo(options)
  } else if (isAndroidApp()) {
    const options = {
      targetClass: 'com.kidswant.component.h5.HZWJsHandler',
      methodType: '0',
      methodName: 'invokeAppShare',
      methodArgsTypes: 't,b',
      parm: [
        {
          parmClass: 's',
          parmKey: 'channel',
          parmValue: '5'
        }
      ]
    }
    setNativeInfo(options)
  }
}

/* 拉起分享到微信朋友圈 */
export function openShareWxMoment() {
  if (isIosApp()) {
    const options = {
      targetClass: '',
      methodType: '0',
      methodName: 'singleShareType_',
      parm: [
        {
          parmClass: 's',
          parmValue: '8'
        }
      ]
    }
    setNativeInfo(options)
  } else if (isAndroidApp()) {
    const options = {
      targetClass: 'com.kidswant.component.h5.HZWJsHandler',
      methodType: '0',
      methodName: 'invokeAppShare',
      methodArgsTypes: 't,b',
      parm: [
        {
          parmClass: 's',
          parmKey: 'channel',
          parmValue: '5'
        }
      ]
    }
    setNativeInfo(options)
  }
}

/* 拉起微信App */
export function openWx() {
  // kwsdk.openWx() // 安卓拉起微信有点问题
  if (isIosApp()) {
    const options = {
      targetClass: 'KTemaiJsConfig',
      methodType: '1',
      methodName: 'openWxApp',
      parm: []
    }
    setNativeInfo(options)
  } else if (isAndroidApp()) {
    const options = {
      targetClass: 'com.kidswant.component.h5.HZWJsHandler',
      methodType: '0',
      methodArgsTypes: 't,b',
      methodName: 'openWeiXin',
      parm: [
        {
          parmClass: 's',
          parmKey: 'url',
          parmValue: 'cmd=openWeiXin'
        }
      ]
    }
    setNativeInfo(options)
  }
}

export const getMmzLocation = async (): Promise<any> => {
  return new Promise((resolve, reject) => {
    let id: any = 0
    window.gpsCallback = async (latitude_longitude: string) => {
      clearTimeout(id)
      if (
        latitude_longitude &&
        typeof latitude_longitude === 'string' &&
        latitude_longitude.indexOf('_') > -1
      ) {
        const [lat, lng] = latitude_longitude.split('_')
        const result = await geoCoderByLatLng(lat, lng)
        resolve(result)
      } else {
        reject()
      }
    }
    id = setTimeout(() => {
      console.log('[ 超时了 ]')
      reject()
    }, 2000)
    if (isIosApp()) {
      window.localjs.startgps()
    } else {
      const options = {
        targetClass: 'com.kidswant.component.h5.HZWJsHandler',
        methodType: '0',
        methodName: 'startGps',
        methodArgsTypes: 't,b',
        parm: []
      }
      window.localjs &&
        window.localjs.invokeNativeMethod &&
        window.localjs.invokeNativeMethod(JSON.stringify(options))
    }
  })
}

type LatLngType = {
  lat: string
  lng: string
}
/* 是否允许页面分享及刷新 */
export function allowRefreshOrShare(refresh = true, share = true): void {
  kwsdk.refreshOrShare({ refresh, share })
}

/* 下载图片视频并保存到相册，ios一次性回调(成功数)、android逐次回调(已下载次数, 总次数, 错误图片) */
export function saveMediasToAlbum(
  urls: string[],
  callback?: (...params: any[]) => any
) {
  if (isIosApp()) {
    const options = {
      targetClass: 'KTemaiJsConfig',
      methodType: '1',
      methodName: 'savePicsAndVideosArray_callback_',
      parm: [
        {
          parmClass: 's',
          parmValue: JSON.stringify({
            image: urls
          })
        }
      ]
    }
    let callbackName
    if (typeof callback == 'function') {
      window.downloadCallback = callback
      callbackName = 'downloadCallback'
    } else {
      delete window.downloadCallback
    }
    setNativeInfo(options, callbackName)
  } else if (isAndroidApp()) {
    const options = {
      targetClass: 'com.kidswant.component.h5.HZWJsHandler',
      methodType: '0',
      methodName: 'kwBatchSaveImageWithUrl',
      methodArgsTypes: 't,b',
      parm: [
        {
          parmClass: 's',
          parmKey: 'picUrlList',
          parmValue: JSON.stringify({
            urlList: urls
          })
        }
      ]
    }
    let callbackName
    if (typeof callback == 'function') {
      window.kwBatchSavePicCallBack = callback
      callbackName = 'kwBatchSavePicCallBack'
    } else {
      delete window.kwBatchSavePicCallBack
    }
    setNativeInfo(options, callbackName)
  }
}

export function getAppHeaderHeight() {
  return kwsdk.getHeaderHeight()
}

type HeaderType = Partial<{
  mainColor: string
  defaultBgColor: string
  startBgColor: string
  endBgColor: string
  hideTitle: string
  titleText: string
  gradualBgColor: string
  gradualTitleColor: string
}>
export function setAppHeader(value: HeaderType) {
  kwsdk.setHeader(value)
}

/*
 *********************** 企业微信原生方法 ***********************
 */
/* 是否在企业微信中 */
export function isInWorkChat(): boolean {
  return kwworkchat.isInWorkChat()
}

/* 初始化配置 */
export function initWorkchatConfig() {
  if (kwworkchat.isInWorkChat() && !parentKwworkchat) {
    kwworkchat
      .initConfig({
        corpId,
        agentId,
        corpSignCode,
        appSignCode,
        jsApiList: [
          'getContext',
          'sendChatMessage',
          'shareToExternalMoments',
          'getLocation',
          'launchMiniprogram',
          'getCurExternalContact',
          'getCurExternalChat',
          'shareToExternalContact',
          'shareToExternalChat',
          'openEnterpriseChat'
        ]
      })
      .then(() => {
        console.log('初始化配置成功～')
      })
      .catch((reason: any) => {
        console.error(`初始化配置失败: ${reason}`)
        Toast(`初始化配置失败: ${reason}`)
      })
  }
}

/* 获取企业微信的定位经纬度 */
async function getWorkchatLatAndLng(): Promise<LatLngType | null> {
  try {
    const location = await kwworkchat.getLocation('wgs84')
    const { latitude, longitude } = location
    if (latitude && longitude) {
      return {
        lat: `${location.latitude}`,
        lng: `${location.longitude}`
      }
    } else {
      return null
    }
  } catch (e) {
    console.error(`获取当前经纬度失败`, e)
    return null
  }
}
/* 获取企业微信的经纬度信息并转化出城市 */
export async function getWorkChatLocation(): Promise<LocationType | null> {
  try {
    const position = await getWorkchatLatAndLng()
    if (position) {
      const result = await geoCoderByLatLng(position.lat, position.lng)
      return result
    }
    return null
  } catch (e) {
    return null
  }
}

/* 跳转已关联企业微信的小程序 */
/* https://developer.work.weixin.qq.com/document/path/93098 */
export async function launchMiniProgram(config: {
  path?: string
  link?: string
}) {
  return new Promise((resolve, reject) => {
    // 不用kw-workchat里面封装的方法，有问题
    ww.invoke(
      'launchMiniprogram',
      {
        appid: 'wx38c03f55ea0ab651',
        path:
          config.path ||
          `pages/mall-index/index?refererH5=${encodeURIComponent(
            config.link || location.href
          )}`
      },
      (res: any) => {
        if (res.errMsg == 'launchMiniprogram:ok') {
          resolve('success')
        } else {
          reject(res.errMsg)
        }
      }
    )
  })
}

/* 获取图片视频的mediaId */
export async function getWorkChatMediaId(
  type: 'image' | 'video',
  media: string | File
): Promise<string> {
  let mediaId = ''
  if (type == 'image') {
    if (typeof media == 'string') {
      mediaId = (await getImageMedia(media)).media_id || ''
    } else if (typeof media == 'object') {
      mediaId = (await uploadImageMedia(media)).media_id || ''
    }
  } else if (type == 'video' && typeof media == 'string') {
    mediaId = (await getVideoMedia(media)).media_id || ''
  }
  return mediaId
}

/* 企微场景值 */
export const ChatTools: { [key: string]: string } = {
  singleChat: 'single_chat_tools', //'单聊场景'
  groupChat: 'group_chat_tools', //'群聊场景'
  normal: 'normal' //'普通场景'
}
/* 获取当前页面所在的场景信息 */
export async function getWorkChatContext() {
  try {
    const value = await kwworkchat.getContext()
    const tipObj = {
      [ChatTools.singleChat]: '单聊场景',
      [ChatTools.groupChat]: '群聊场景',
      [ChatTools.normal]: '普通场景'
    }
    console.log(`当前场景`, value, tipObj[value])
    return value
  } catch (e) {
    console.error(e)
    return ChatTools.normal
  }
}

/* 分享消息到当前会话 */
/* https://developer.work.weixin.qq.com/document/path/94797 */
export async function sendChatMessage(message: {
  msgtype: 'text' | 'image' | 'video' | 'file' | 'news' | 'miniprogram' //消息类型，必填
  enterChat: boolean //为true时表示发送完成之后顺便进入会话，仅移动端3.1.10及以上版本支持该字段
  text?: {
    content: string //文本内容
  }
  image?: {
    mediaid: string //图片的素材id
  }
  video?: {
    mediaid: string //视频的素材id
  }
  file?: {
    mediaid: string //文件的素材id
  }
  news?: {
    link: string //H5消息页面url 必填
    title: string //H5消息标题
    desc: string //H5消息摘要
    imgUrl: string //H5消息封面图片URL
  }
  miniprogram?: {
    appid: string //小程序的appid，企业已关联的任一个小程序
    title: string //小程序消息的title
    imgUrl: string //小程序消息的封面图。必须带http或者https协议头，否则报错 $apiName$:fail invalid imgUrl
    page: string //小程序消息打开后的路径，注意要以.html作为后缀，否则在微信端打开会提示找不到页面
  }
}) {
  console.log(message)
  return new Promise((resolve, reject) => {
    // 可以不用kw-workchat里面封装的方法
    ww.invoke('sendChatMessage', message, (res: any) => {
      console.log('sendChatMessage res', res)
      const { errMsg } = res
      if (errMsg == 'sendChatMessage:ok') {
        resolve('success')
      } else {
        reject(errMsg || 'sendChatMessage:error')
      }
    })
  })
}

export type WorkChatAttachmentType = {
  msgtype: 'image' | 'link' | 'miniprogram' | 'video' | 'file'
  image?: {
    mediaid?: string // 图片的素材id
    imgUrl?: string // 图片的imgUrl,跟图片mediaid填其中一个即可
  }
  link?: {
    title: string // H5消息标题
    imgUrl: string // H5消息封面图片URL
    desc: string // H5消息摘要
    url: string // H5消息页面url 必填
  }
  miniprogram?: {
    appid?: string // 小程序的appid
    title: string // 小程序消息的title
    imgUrl: string //小程序消息的封面图。必须带http或者https协议头
    page: string //小程序消息打开后的路径，注意要以.html作为后缀，否则在微信端打开会提示找不到页面
  }
  video?: {
    mediaid: string // 视频的素材id
  }
  file?: {
    mediaid: '' // 文件的素材id，必填
  }
}
/* 企微群发消息至客户 */
/* https://developer.work.weixin.qq.com/document/path/93555 */
export async function shareToExternalContact(message: {
  text?: {
    content: string // 文本内容
  }
  attachments?: WorkChatAttachmentType[]
}) {
  console.log(message)
  return new Promise((resolve, reject) => {
    // 不用kw-workchat里面封装的方法，有问题
    ww.invoke('shareToExternalContact', message, (res: any) => {
      console.log('shareToExternalContact res', res)
      const { errMsg } = res
      if (errMsg == 'shareToExternalContact:ok') {
        resolve('success')
      } else {
        reject(errMsg || 'shareToExternalContact:error')
      }
    })
  })
}
/* 企微群发消息至客户群 */
/* https://developer.work.weixin.qq.com/document/path/93555 */
export async function shareToExternalChat(message: {
  text?: {
    content: string // 文本内容
  }
  attachments?: WorkChatAttachmentType[]
}) {
  console.log(message)
  return new Promise((resolve, reject) => {
    // 不用kw-workchat里面封装的方法，有问题
    ww.invoke('shareToExternalChat', message, (res: any) => {
      console.log('shareToExternalChat res', res)
      const { errMsg } = res
      if (errMsg == 'shareToExternalChat:ok') {
        resolve('success')
      } else {
        reject(errMsg || 'shareToExternalChat:error')
      }
    })
  })
}

/* 企微分享至朋友圈，始终带文字，有图分享图(目前kw-workchat视频分享朋友圈暂不支持) */
/* https://developer.work.weixin.qq.com/document/path/94607 */
export async function shareToExternalMoments(message: {
  text?: {
    content: string // 文本内容
  }
  attachments?: WorkChatAttachmentType[]
}) {
  console.log(message)
  return new Promise((resolve, reject) => {
    // 不用kw-workchat里面封装的方法，目前kw-workchat视频分享朋友圈暂不支持
    ww.invoke('shareToExternalMoments', message, (res: any) => {
      console.log('shareToExternalMoments res', res)
      const { errMsg } = res
      if (errMsg == 'shareToExternalMoments:ok') {
        resolve('success')
      } else {
        reject(errMsg || 'shareToExternalMoments:error')
      }
    })
  })
}

/* 获取当前外部联系人ID  */
export async function getCurExternalContactId() {
  if (!kwworkchat.isInWorkChat()) {
    return undefined
  }
  const workChatContext = await getWorkChatContext()
  if (workChatContext != ChatTools.singleChat) {
    return undefined
  }
  return new Promise(resolve => {
    kwworkchat
      .getCurExternalContact()
      .then((externalId: string) => {
        console.log(`获取当前外部联系人ID 成功：${externalId}`)
        resolve(externalId)
      })
      .catch((reason: any) => {
        console.log(`获取当前外部联系人ID 失败：${reason}`)
        resolve(undefined)
      })
  })
}

/* 获取当前所在群ID */
export async function getCurExternalChatId() {
  if (!kwworkchat.isInWorkChat()) {
    return undefined
  }
  const workChatContext = await getWorkChatContext()
  if (workChatContext != ChatTools.groupChat) {
    return undefined
  }
  return new Promise(resolve => {
    kwworkchat
      .getCurExternalChat()
      .then((chatId: string) => {
        console.log(`获取当前群ID 成功：${chatId}`)
        resolve(chatId)
      })
      .catch((reason: any) => {
        console.log(`获取当前群ID 失败：${reason}`)
        resolve(undefined)
      })
  })
}
